import { track } from '@amplitude/analytics-browser'

/**
 * Custom hook for tracking events with Amplitude
 * @param {string} eventName - The name of the event to track
 * @param {Object} [properties] - Optional properties to track with the event
 * @returns {Function} - A function that can be called to track the event
 */
const useTrackerFunction = (eventName, properties = {}) => {
  const trackEvent = (additionalProperties = {}) => {
    try {
      // Merge the base properties with any additional properties passed at call time
      const eventProperties = {
        ...properties,
        ...additionalProperties,
      }

      // Track the event with Amplitude
      track(eventName, eventProperties)

      // You can add other analytics providers here in the future
      // For example:
      // if (window.gtag) {
      //   window.gtag('event', eventName, eventProperties);
      // }
    } catch (error) {
      console.error('Error tracking event:', error)
    }
  }

  return trackEvent
}

export default useTrackerFunction
